module.exports = __webpack_public_path__ + "img/search-loader.06c38d88.gif";